const CSSGlobalVars = {
    phoneCap:850,
    primaryColor:'#3250ED'
}


export default CSSGlobalVars;